
import React from 'react'
import { Input, Button, Space, Select, Popover, Tabs } from 'antd';
import Card from '../com/internship/card';
import Config from "../../config/Config";
import EventBus from "../../frame/eventBus";
import WidgetAjax from '../../widget/WidgetAjax';

import { checkLogin, tagRedirect } from '../../pages/com/utils';
import { CaretDownOutlined } from '@ant-design/icons';
import JobType from '../home/com/JobType';
let path = Config.getBasePath();
let filePath = Config.getFilePath();

class internship extends React.Component {
  constructor(props) {
    super(props)
    this.state = {

      jobTypeLoading: true,
      bannerList: [
        { title: "智能简历撰写", icon: require("../../img/pinzhunzhun/dataSource/banner1.png"), onClick: () => this.aiChat("resume") },
        { title: "精准岗位推荐", icon: require("../../img/pinzhunzhun/dataSource/banner2.png"), onClick: () => this.aiChat("岗位推荐") },
        { title: "就业面试辅助", icon: require("../../img/pinzhunzhun/dataSource/banner3.png"), onClick: () => this.aiChat("officer") },
      ],

      screenType: [
        { title: "热门实习", title_html: <><div style={{ color: '#3D413E' }}>热门</div>实习</>, tips: '为就业打基础', name: "hot_internship", img: require("../../img/pinzhunzhun/dataSource/icon_hot_internship.png") },
        { title: '热门企业', title_html: <><div style={{ color: '#3D413E' }}>热门</div>企业</>, tips: '大家都在投，名企好未来！', name: "hot_ent", img: require("../../img/pinzhunzhun/dataSource/icon_hot_ent.png") }],
      jobData: [],
      TabsData: [
        {
          key: "02",
          label: `全部`,
        },
        {
          key: '0201',
          label: `暑期实习`,
        },
        {
          key: '0202',
          label: `名企实习`,
        },
        {
          key: '0203',
          label: `集中实习`,
        },
      ],
      tabsValue: '02'
    }
  }
  async componentDidMount() {
    const search = window.location.search;
    const params = new URLSearchParams(search);

    let userInfo = sessionStorage.getItem("_user_info_");
    if (userInfo) {
      userInfo = JSON.parse(userInfo);
      let location = JSON.parse(sessionStorage.getItem("_user_location_"));
      await this.setState({ userInfo: userInfo, location });

    }
    if (params) {
      // 获取指定参数的值
      const param1 = params.get('param1');
      const param2 = params.get('param2');
    }
    this.jobTypeList();
    this.jobList();
    this.entSearch();
    if (sessionStorage.getItem("_user_access_")) {
      this.getUserInfo();
    }
    EventBus.on('locationChange', this.locationChange);
    this.hotList();
  }

  componentWillUnmount() {
    EventBus.off('locationChange', this.locationChange);
  }

  locationChange = async (location) => {
    await this.setState({ location });
    this.hotList();
    this.jobList();
    this.entSearch();
  }

  componentWillReceiveProps() {
    let userInfo = sessionStorage.getItem("_user_info_");

    if (userInfo) {
      userInfo = JSON.parse(userInfo);

      this.setState({ userInfo: userInfo });
    }
  }

  getUserInfo = () => {

    const onUserInfo = (res) => {
      if (res.status == 0) {
        this.setState({ user: res.result });
      }
    }

    WidgetAjax.ajax({ url: path + '/applicant/resume_info', params: {}, callback: onUserInfo });

  }

  /**
   * 热词
   */
  hotList = () => {
    const { location } = this.state;
    let params = {
      // type: 'campus',
      // category: '02',
      // search_type: 'job',
      // district: location?.value
      DISTRICT: location?.value,
      type: 'job',
      limit: 6
    }
    const onHotList = (res) => {
      if (res.status == 0) {
        this.setState({ hotData: res.results });
      }
    }
    WidgetAjax.ajax({
      url: path + '/recommend/search_hot',
      params,
      callback: onHotList
    });
  }


  jobTypeList = async () => {
    await this.setState({ jobTypeLoading: true });
    const onJobTypeList = (res) => {
      if (res.status === 0) {
        if (res.results && res.results.length) {
          let jobTypeData = res.results.filter((item) => item.name !== "常用岗位");
          this.setState({ jobTypeData });
        }
        this.setState({ jobTypeLoading: false });
      }
    };
    WidgetAjax.ajax({
      url: path + '/recruitment/job_type',
      params: { parent_code: "0" },
      callback: onJobTypeList
    });
  }



  jobList = () => {
    const { location, tabsValue } = this.state;
    let params = {
      type: 'campus',
      category: tabsValue,
      page: 1, records: 9,
      DISTRICT: location ? [location?.value] : undefined,
      query: "*"
    }
    const onJobList = (res) => {
      if (res.status == 0) {
        this.setState({ jobData: res.results });
      }
    }
    WidgetAjax.ajax({ url: path + '/recommend/job_list', params, callback: onJobList });
  }




  entSearch = () => {
    const { location } = this.state;
    const onEntSearch = (res) => {
      if (res.status == 0) {
        if (res.results && res.results.length > 0) {
          let entData = res.results.map((item) => {
            return { ...item }
          })
          this.setState({ entData });

        } else {
          this.setState({ entData: [] })
        }
      }
    }
    WidgetAjax.ajax({
      url: path + '/recommend/enterprise_list',
      params: {
        type: 'campus',
        category: '02',
        district: location ? [location?.value] : undefined,
        // page: 1,
        limit: 6
      },
      callback: onEntSearch
    });
  }




  aiChat = (type) => {
    if (checkLogin()) {
      this.props.history.push({ pathname: "/home/ai-chat", state: { scene: type } });
    } else {
      this.logOut("/home/ai-chat", { scene: type });
    }
  }

  logOut = (URL, state) => {
    this.props.history.push({ pathname: URL ? '/login?redirectURL=' + URL : "/login", state });
    window.location.reload();

  }

  tabsChange = async (value) => {
    await this.setState({ tabsValue: value });
    this.jobList();
  }

  screenType = (obj) => {
    const { jobData, entData, TabsData } = this.state;
    let children = <div className='tabs_box'>
      <Tabs items={TabsData} onChange={this.tabsChange} />
    </div>
    switch (obj?.title) {
      case "热门实习":
        return <>
          {/* //children={children} */}
          <Card obj={obj} data={jobData} type={'job'} history={this.props.history} />
        </>
      // case "热门企业":
      //   return <Card obj={obj} data={entData} type={'ent'} history={this.props.history} />
      default:
        return ""
    }


  }

  tagRedirect = () => {
    const currentUrl = window.location.href;
    const homeIndex = currentUrl.indexOf('home/');
    if (homeIndex !== -1) {
      let newUrl = currentUrl.substring(0, homeIndex + 'home/'.length);
      const params = new URLSearchParams();
      newUrl = newUrl + 'profession'
      let urlWithParams = `${newUrl}?${params.toString()}`;
      window.open(urlWithParams, '_blank');
    }
  }

  toSearch = () => {
    const { searchValue } = this.state;
    tagRedirect({ WKEXP: '1,2', word: searchValue }, "recommendedJob")
  }



  notify = (tab) => {
    if (checkLogin()) {
      if (tab === '5') {
        this.props.history.push({ pathname: "/home/resume" });
      } else if (tab === '6') {
      } else {
        this.props.history.push({ pathname: "/home/applicant", state: { tab } });
      }
    } else {
      let url;
      let state;
      switch (tab) {
        case "5":
          url = "/home/resume";
          break;
        case "6":
          break;
        default:
          url = "/home/applicant";
          state = { tab };
          break;
      }

      this.logOut(url, state);
    }
  }
  profession = (type) => {
    console.log(type);
    this.props.history.push({
      pathname: "/home/profession/detail",
      state: { name: type }
    });
  }

  setWork = async (value) => {
    await this.setState({ searchValue: value });
    this.toSearch()
  }

  render() {
    const { typeFilter, typeFilterValue, jobTypeData, bannerList, screenType, jobTypeLoading, hotData } = this.state;

    return <div component-data="internship">
      <div className='screen'>
        <div className='head_filter'>
          <div className='box_1200 '>
            <div className='head_filter_box'>
              <img className='home_logo' src={require("../../img/pinzhunzhun/dataSource/internship_icon.svg")} />
              <div className='search_home'>
                <div className='search_box'>
                  <Space.Compact style={{ width: '100%' }}>
                    <Input placeholder="搜索职位关键词" onChange={(e) => { this.setState({ searchValue: e.target.value }) }} />
                    <Button type="primary" onClick={() => { this.toSearch() }} >搜索</Button>
                  </Space.Compact>
                  <img className='ai_recommendation'
                    onClick={() => { this.aiChat("岗位推荐") }}
                    src={require("../../img/pinzhunzhun/dataSource/ai_recommendation.png")} />
                </div>
                <div className='hot_jobType'>
                  <label> 热门搜索: </label>
                  {
                    hotData && hotData.map((item) => {
                      return <div className='hot_item' onClick={() => this.setWork(item.word)}> {item.word}</div>
                    })
                  }
                </div>
              </div>
              <div className='board_qrCode' >
                {/* <Popover placement="right" content={<img src={require("../../img/pinzhunzhun/dataSource/service_Code.png")} />}>
                  <a>扫码进公众号</a>
                </Popover> */}
                {/* <Popover placement="right" content={<img src={require("../../img/pinzhunzhun/dataSource/service_Code.png")} />}>
                  <a>扫码进求职招聘小程序</a>
                </Popover> */}
              </div>
            </div>
          </div>
        </div>

        <div className='box_1200 ' style={{ paddingTop: '150px' }}>

          <div className='box_banner'>

            <JobType data={jobTypeData} loading={jobTypeLoading} options={{ records: 10 }} history={this.props?.history} />
            <div className='job_banner'>
              <div className='template1'>
                <img className='template1_01' src={require("../../img/pinzhunzhun/internship/banner_01.png")} />
                {/* <div>
                  {
                    bannerList.map((item, index) => {
                      return <div onClick={item?.onClick}>
                        <img className='template1_02' src={item?.icon} />
                      </div>
                    })
                  }
                </div> */}
              </div>
              <div className='template2'>
                <img className='template' src={require("../../img/pinzhunzhun/internship/banner_02.png")} />
                <img className='template' src={require("../../img/pinzhunzhun/internship/banner_03.png")} />
              </div>
            </div>
          </div>
          <div className='omnibus'>
            {
              screenType.map((item) => {
                return this.screenType(item);
              })
            }
          </div>

        </div>
      </div>
    </div>
  }
}

export default internship;